import { FC } from 'react';
import { useTranslate } from 'hooks/useTranslate';

const DefaultTableHeader: FC = () => {
  const { t } = useTranslate();

  return (
    <>
      <thead className="tb-head">
        <tr>
          <th className="text-left">{t('Partner')}</th>
          <th className="text-left">{t('Class')}</th>
          <th className="text-center">{t('Price')}</th>
          <th className="text-center">{t('From')}</th>
          <th className="text-center">{t('To')}</th>
        </tr>
      </thead>
    </>
  );
};

export default DefaultTableHeader;
